import { createRef } from "react";
import { SnackbarKey, SnackbarProvider } from "notistack";
import { IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface Props {
  children: React.ReactNode;
}
export function RootLayout(props: Props) {
  // add action to all snackbars
  const notistackRef = createRef<SnackbarProvider>();

  function onClickDismiss(key: SnackbarKey) {
    notistackRef?.current?.closeSnackbar(key);
  }

  return render();

  function render() {
    return (
      <SnackbarProvider
        maxSnack={3}
        ref={notistackRef}
        autoHideDuration={5000}
        action={(key: SnackbarKey) => (
          <IconButton onClick={() => onClickDismiss(key)} size="large">
            <CloseIcon />
          </IconButton>
        )}
      >
        {props.children}
      </SnackbarProvider>
    );
  }
}
